import { render, staticRenderFns } from "./PlanTwo.vue?vue&type=template&id=b3b934d2&scoped=true&"
import script from "./PlanTwo.vue?vue&type=script&lang=js&"
export * from "./PlanTwo.vue?vue&type=script&lang=js&"
import style0 from "./PlanTwo.vue?vue&type=style&index=0&id=b3b934d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b934d2",
  null
  
)

export default component.exports